import { HttpInterceptorFn } from '@angular/common/http';
import { first, tap } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { inject } from '@angular/core';
import { AccountService } from 'services/account.service';

export const companyInterceptor: HttpInterceptorFn = (request, next) => {
  const excludedEndpoints = ['api/v1/companies'];
  const allowedEndpoints = ['api/v1/companies/secret'];

  return inject(AccountService)
    .getSelectedCompany$()
    .pipe(
      first(),
      tap((company) => {
        if (
          company &&
          (!excludedEndpoints.some((endpoint) => request.url.includes(endpoint)) ||
            allowedEndpoints.some((endpoint: string): boolean => request.url.includes(endpoint)))
        ) {
          request = request.clone({
            setHeaders: { 'X-CYAN-COMPANY-USER-ID': `${company.userId}` }
          });
        }
      }),
      switchMap(() => next(request))
    );
};
